/** Email delivery choice in Notification settings (each email right away or one daily digest) and the fetch failed, password change, new sign-in, storage running and email bounced notices. */
export const notifyDigestEn={
 "notify.digest":"Email delivery",
 "notify.digestNote":"Urgent notices, like failed or unknown sends, are always emailed right away.",
 "notify.digestOff":"Send each email right away",
 "notify.digestOn":"One daily digest",
 "notify.digestAt":"Digest time",
 "notice.fetch_failed":"Fetch failed",
 "notice.fetchDetail":"{name} couldn’t be updated. Check the connection.",
 "notice.security_change":"Your password was changed",
 "notice.securityDetail":"If this wasn’t you, reset your password now.",
 "notice.new_sign_in":"New sign-in to your account",
 "notice.signInDetail":"{name}. If this wasn’t you, reset your password now.",
 "notice.storage_running":"Storage is running",
 "notice.storageDetail":"{n, plural, one {# vehicle past its last free day is still at the yard} other {# vehicles past their last free day are still at the yard}}",
 "notify.ev.storage_running":"Storage running",
 "notify.evSub.storage_running":"A vehicle past its last free day hasn’t been picked up.",
 "notify.example.storage_running":"2 vehicles are paying storage at the yard.",
 "notice.send_bounced":"Email bounced",
 "notice.bounceDetail":"{to} doesn’t accept mail. Check the address.",
 "notify.ev.send_bounced":"Email bounced",
 "notify.evSub.send_bounced":"A customer’s mail server refused an email you sent.",
 "notify.example.send_bounced":"buyer@customer.com doesn’t accept mail."
};
export const notifyDigestRu:Record<keyof typeof notifyDigestEn,string>={
 "notify.digest":"Доставка писем",
 "notify.digestNote":"О срочных уведомлениях, например неудачных или неизвестных отправках, письмо приходит сразу.",
 "notify.digestOff":"Отправлять каждое письмо сразу",
 "notify.digestOn":"Одна сводка в день",
 "notify.digestAt":"Время сводки",
 "notice.fetch_failed":"Ошибка получения данных",
 "notice.fetchDetail":"Не удалось обновить {name}. Проверьте подключение.",
 "notice.security_change":"Пароль изменён",
 "notice.securityDetail":"Если это были не вы, сразу сбросьте пароль.",
 "notice.new_sign_in":"Новый вход в учётную запись",
 "notice.signInDetail":"{name}. Если это были не вы, сразу сбросьте пароль.",
 "notice.storage_running":"Идёт платное хранение",
 "notice.storageDetail":"{n, plural, one {# машина после последнего бесплатного дня ещё на площадке} few {# машины после последнего бесплатного дня ещё на площадке} many {# машин после последнего бесплатного дня ещё на площадке} other {# машины после последнего бесплатного дня ещё на площадке}}",
 "notify.ev.storage_running":"Платное хранение",
 "notify.evSub.storage_running":"Машину не забрали после последнего бесплатного дня.",
 "notify.example.storage_running":"За 2 машины на площадке начисляется хранение.",
 "notice.send_bounced":"Письмо не доставлено",
 "notice.bounceDetail":"{to} не принимает почту. Проверьте адрес.",
 "notify.ev.send_bounced":"Письмо не доставлено",
 "notify.evSub.send_bounced":"Почтовый сервер клиента отклонил ваше письмо.",
 "notify.example.send_bounced":"buyer@customer.com не принимает почту."
};
export const notifyDigestKo:Record<keyof typeof notifyDigestEn,string>={
 "notify.digest":"이메일 전송",
 "notify.digestNote":"실패하거나 결과를 알 수 없는 전송 같은 긴급 알림은 항상 바로 이메일로 보냅니다.",
 "notify.digestOff":"각 이메일을 바로 보내기",
 "notify.digestOn":"하루 한 번 요약",
 "notify.digestAt":"요약 시간",
 "notice.fetch_failed":"가져오기 실패",
 "notice.fetchDetail":"{name}을(를) 업데이트하지 못했습니다. 연결을 확인하세요.",
 "notice.security_change":"비밀번호가 변경됨",
 "notice.securityDetail":"본인이 아니라면 지금 비밀번호를 재설정하세요.",
 "notice.new_sign_in":"계정에 새 로그인",
 "notice.signInDetail":"{name}. 본인이 아니라면 지금 비밀번호를 재설정하세요.",
 "notice.storage_running":"보관료 발생 중",
 "notice.storageDetail":"{n, plural, other {마지막 무료일이 지난 차량 #대가 아직 야드에 있습니다}}",
 "notify.ev.storage_running":"보관료 발생",
 "notify.evSub.storage_running":"마지막 무료일이 지난 차량이 아직 픽업되지 않았습니다.",
 "notify.example.storage_running":"차량 2대에 야드 보관료가 발생하고 있습니다.",
 "notice.send_bounced":"이메일 반송됨",
 "notice.bounceDetail":"{to} 주소는 메일을 받지 않습니다. 주소를 확인하세요.",
 "notify.ev.send_bounced":"이메일 반송",
 "notify.evSub.send_bounced":"보낸 이메일을 고객의 메일 서버가 거부했습니다.",
 "notify.example.send_bounced":"buyer@customer.com 주소는 메일을 받지 않습니다."
};
